{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "urn:cogo:document-template-input:standard-report:v1",
  "title": "Standard report input",
  "type": "object",
  "additionalProperties": false,
  "required": ["cover", "toc", "summary", "body", "appendix"],
  "properties": {
    "cover": {
      "type": "string",
      "minLength": 1
    },
    "toc": {
      "type": "array",
      "minItems": 1,
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": ["label", "pageRef"],
        "properties": {
          "label": {
            "type": "string",
            "minLength": 1
          },
          "pageRef": {
            "type": "string",
            "minLength": 1
          }
        }
      }
    },
    "summary": {
      "type": "string",
      "minLength": 1
    },
    "body": {
      "type": "string",
      "minLength": 1
    },
    "appendix": {
      "type": "string",
      "minLength": 1
    }
  }
}
